<script setup lang="ts">
import { Sparkles } from 'lucide-vue-next';
import EmptyState from '@/components/shared/EmptyState.vue';
</script>

<template>
    <div class="p-4">
        <EmptyState
            :icon="Sparkles"
            title="Assistant indisponible"
            description="L'assistant d'écriture sera bientôt disponible."
            class="border-border/40"
        />
    </div>
</template>
